import { getRUM } from '@codametrix/client-observability';
export interface NavInstrumentationService {
  setGlobalContext(context: string): void;
  restorePreviousContext(): void;
  trackNavOptionSet(options: any[]): void;
  trackItemActivated(item: any, source: string): void;
}

export class DatadogNavInstrumentation implements NavInstrumentationService {
  private previousContext: string | null = null;

  setGlobalContext(context: string): void {
    const globalContext = getRUM().getGlobalContext?.() ?? {};
    this.previousContext = globalContext.service ?? null;
    
    // Set new context
    getRUM().setGlobalContextProperty('observation_service', `${context}-frontend`);
  }

  restorePreviousContext(): void {

    getRUM().setGlobalContextProperty('service', this.previousContext);
    this.previousContext = null;
  }

  trackNavOptionSet(options: any[]): void {
    getRUM().addAction('nav_options_set', {
      option_count: options.length,
      timestamp: Date.now()
    });
  }

  trackItemActivated(item: any, source: string): void {
    
    const serviceContext = item.observationService || item.id;

    // Set global context before navigation
    this.setGlobalContext(serviceContext);

    getRUM().addAction('nav_item_activated', {
      item_id: item.id,
      item_label: item.label,
      source: source,
      is_sub_action: !!item.resourceId,
      parent_id: item.parentId,
      timestamp: Date.now()
    });
  }
}

export const navInstrumentation = new DatadogNavInstrumentation();
